import React from 'react';

const Hero = () => {
    return (
        <section className="hero-header container mx-auto mb-10">
		<div className=" bg-gradient-to-r from-base-300 via-base-200 to-base-100 rounded-3xl shadow-xl w-10/12 lg:w-full mx-auto">
            
			<div className="hero-content  lg:flex-row flex-col max-w-full items-end p-0 justify-between">
                <div className="lg:w-1/12">

                </div>
				<div className="Lg:w-5/12 md:w-10/12 py-20">
					<h1 className="lg:text-8xl md:text-7xl text-3xl font-bold skew-y-12">
						<span className="">
							LET’S  <br />
						</span>
						 EXPLORE <br />
						<span className="bg-primary text-black px-6 lg:text-9xl md:text-8xl text-4xl">GAMING </span> <br />
						Tools.
					</h1>
					<p className="py-6">
                    Live for Influential and Innovative As A Gamer!
					</p>
					<button className="btn btn-secondary w-2/3 mx-auto">Shop Now</button>
				</div>
		
            <div className="lg:w-5/12 md:w-10/12">
					<img
						src={process.env.PUBLIC_URL + "img/hero-header-img.png"}
						className="lg:items-end items-start"
						alt="hero-header"
					/>
				</div>
                </div>
		</div>
        </section>
    );
};

export default Hero;